// extracted by mini-css-extract-plugin
module.exports = {"servicesBlock":"ServiceBlock_servicesBlock__3NXBM","cardIcon":"ServiceBlock_cardIcon__1xu12"};